import Landing from '../views/Landing/Index'
import ContactLanding from '../views/Landing/Contact'
import TermsConditionsChuspic from '../views/Landing/TermConditionsChuspic'
import PrivacyPoliciesChuspic from '../views/Landing/PrivacyPoliciesChuspic'
import Register from '../views/Landing/Register'
import Plans from '../views/Landing/Plans'

const LAYOUT = 'ChuspicLayoutWeb';

export const LandingRouter = [
    {
        path: '/landing',
        name: 'Landing',
        component: Landing,
        meta: {layout: LAYOUT}
    },
    {
        path: '/landing/contact',
        name: 'ContactLanding',
        component: ContactLanding,
        meta: {layout: LAYOUT}
    },
    {
        path: '/landing/terms-conditions',
        name: 'TermsConditionsChuspic',
        component: TermsConditionsChuspic,
        meta: {layout: LAYOUT}
    },
    {
        path: '/landing/privacy-policies',
        name: 'PrivacyPoliciesChuspic',
        component: PrivacyPoliciesChuspic,
        meta: {layout: LAYOUT}
    },
    {
        path: '/landing/register',
        name: 'Register',
        component: Register,
        meta: {layout: LAYOUT}
    },
    {
        path: '/landing/plans',
        name: 'Plans',
        component: Plans,
        meta: {layout: LAYOUT}
    },
];